import { render, staticRenderFns } from "./ImageMessageBalloonMultiImages.vue?vue&type=template&id=dd99720c&scoped=true&"
import script from "./ImageMessageBalloonMultiImages.vue?vue&type=script&lang=js&"
export * from "./ImageMessageBalloonMultiImages.vue?vue&type=script&lang=js&"
import style0 from "./ImageMessageBalloonMultiImages.vue?vue&type=style&index=0&id=dd99720c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd99720c",
  null
  
)

export default component.exports